<script lang="ts">
  import { goto } from "$app/navigation";
  import { page } from "$app/stores";
  import { onMount } from "svelte";
  import { session } from "$lib/stores/auth";
  import UserSwitchBar from "$lib/components/UserSwitchBar.svelte";

  let { children } = $props();

  onMount(() => {
    document.documentElement.classList.add("dark");
  });

  // Rutas públicas: fuera del gate de auth (login + seguimiento de envío).
  const isPublicRoute = (path: string): boolean =>
    path.startsWith("/login") || path.startsWith("/q/");

  // Auth gate: cualquier ruta no pública requiere sesión.
  $effect(() => {
    const path = $page.url.pathname;
    if (isPublicRoute(path)) return;
    if (!$session) goto("/login");
  });
</script>

{#if !$page.url.pathname.startsWith("/q/")}
  <UserSwitchBar />
{/if}

<main>
  {@render children?.()}
</main>

<style>
  :global(:root) {
    /* UX-8: texto "muted"/secundario — antes cada pantalla usaba su propio
       gris hardcodeado (#8d95a8, #9aa0ad, opacity trick…), varios por debajo
       de 4.5:1 de contraste sobre el fondo oscuro. Token único, más claro,
       para que las páginas nuevas/tocadas lo referencien en vez de inventar
       otro gris. */
    --text-muted: #9aa3b8;
  }
  :global(html, body) {
    margin: 0;
    padding: 0;
    background: #0f1115;
    color: #e7e9ee;
    font-family: system-ui, -apple-system, "Segoe UI", sans-serif;
    min-height: 100%;
  }
  /* Layout simple: el documento scrollea naturalmente. El topbar
     `UserSwitchBar` usa position: sticky para quedarse arriba mientras
     se scrollea. Páginas que necesiten one-viewport (ej. tablero) usan
     `height: calc(100dvh - 56px); overflow: hidden` localmente. */
  main { display: block; }
</style>
